import React, { useState, memo, useEffect, useRef } from "react";
import { Col, Row, Avatar, message, Modal, Form, Divider, Button } from "antd";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import {
  LikeOutlined,
  DislikeOutlined,
  CopyOutlined,
  UserOutlined,
  RobotOutlined,
  SyncOutlined,
  FullscreenOutlined,
} from "@ant-design/icons";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { PrimaryColor, ScreenSize } from "utils/constants";
import KnowledgeBaseApi from "../../../../../../apis/knowledgeBase";
import { Input } from "antd/lib";
import Image from "next/image";
import Lottie from "lottie-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faCirclePlay } from "@fortawesome/free-regular-svg-icons";
import ChatLoadingAnimation from "../../../../../../images/lottie/ChatLoading.js";
import SearchKnowledgeAnimation from "../../../../../../images/lottie/SearchKnowledgeLoading.json";
import { TypeAnimation } from "react-type-animation";
import SyntaxHighlighter from "react-syntax-highlighter";
import { atomOneDark } from "react-syntax-highlighter/dist/esm/styles/hljs";
import AudioPlayer from "react-h5-audio-player";

const ChatBox = ({
  data,
  previousSelected,
  currentSelected,
  id,
  question,
  action,
  text = "system" | "user",
  type,
  hideAction = false,
  status = "waiting" | "received",
  projectId,
  setInput,
  regenerateInput,
  setRegenerateInput,
  onSubmit,
  setConversationStarterVisible,
  handleRegenerate,
  disabled,
  connectionError,
  projectDetail,
  audioUrl,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [liked, setLiked] = useState(false);
  const [disliked, setDisliked] = useState(false);
  const [visible, setVisible] = useState(false);
  const [linkClick, setLinkClick] = useState(false);

  // checking if user has already liked or disliked the answer
  const [
    checkLikedOrDisLikedTrigger,
    setCheckLikedOrDisLikedTrigger,
  ] = useState(false);

  useEffect(() => {
    if (linkClick) {
      onSubmit();
    }

    setTimeout(() => {
      setLinkClick(false);
    }, 500);

    return () => {};
  }, [linkClick]);

  const ChatComment = async (likedOrDisliked, values) => {
    setLoading(true);

    const res = await KnowledgeBaseApi.chatComment({
      likedOrDisliked,
      id: currentSelected.id,
      question: previousSelected.text,
      answer: currentSelected.text,
      comment: values ? values.comment : null,
      projectId: projectId,
    });
    console.log("res", res);
    // if (res.status !== "error") {
    setLoading(false);

    switch (likedOrDisliked) {
      case "liked":
        setLiked(true);
        setCheckLikedOrDisLikedTrigger(true);
        break;

      case "disliked":
        setDisliked(true);
        setVisible(false);
        setCheckLikedOrDisLikedTrigger(true);
        break;

      default:
        break;
    }

    message.success("Thank you for your feedback");
    // }
  };

  const onFinish = (values) => {
    setLoading(true);

    // const res = await FleetApi.addEditFleet(
    //   formData,
    //   userId ? "patch" : "post",
    //   userId
    // );

    // console.log("res", res);

    setLoading(false);

    // if (res.status !== "error") {
    message.success("Configuration Saved!");
    // }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed to login", errorInfo);
  };

  const actionButtonStyle = {
    style: {
      // padding: 6,
      paddingLeft: 4,
      // border: "1px solid rgba(0,0,0,0.15)",
      borderRadius: 5,
      // backgroundColor: "#fff",
      color: "rgba(0,0,0,0.65)",
      marginRight: 8,
      cursor: "pointer",
      fontSize: 16,
    },
  };

  const formLayout = {
    labelCol: {
      xs: { span: 24 },
      md: { span: 4 },
      xl: { span: 4 },
    },
    wrapperCol: {
      xs: { span: 24 },
      md: { span: 16 },
      xl: { span: 16 },
    },
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      md: { span: 24 },
      xl: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      md: { span: 24 },
      xl: { span: 24 },
    },
  };

  const markdownText = "![Logo](/logo/sernsoft_horizontal.png)";

  const CustomImage = (props) => {
    return <Image {...props} width={80} height={80} objectFit="contain" />;
  };

  const CommentModal = (
    <Modal
      // centered
      // width={"90%"}
      destroyOnClose
      afterClose={() => {
        form.resetFields();
      }}
      open={visible}
      title={"Comment"}
      onCancel={() => setVisible(false)}
      // maskClosable={false}
      onOk={async () => {
        const values = await form.validateFields();
        console.log(values);

        Modal.confirm({
          title: "Confirm Leave a Comment?",
          onOk: async () => {
            ChatComment("disliked", values);
          },
        });
      }}
      okButtonProps={{ loading: loading }}
      cancelButtonProps={{ disabled: loading }}
    >
      <div>
        <Divider style={{ marginTop: 12 }} />

        <Form
          form={form}
          autoComplete="off"
          layout="vertical"
          // colon={false}
          hideRequiredMark
          {...formItemLayout}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            // label="Comment"
            name="comment"
            rules={[
              {
                required: true,
                message: "Comment is required",
              },
            ]}
          >
            <Input.TextArea
              disabled={loading}
              placeholder="Leave a comment..."
              autoSize={{
                minRows: 5,
              }}
              showCount
              maxLength={1000}
            />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );

  const renderers = {
    link: ({ children, href }) => (
      <a
        href={href}
        onClick={() => {
          console.log("children", children);
          console.log("href", href);
        }}
      >
        {children}
      </a>
    ),
  };

  return (
    <div>
      <Row
        justify={"start"}
        style={{
          padding: 16,
        }}
        align={"top"}
      >
        <Col xs={5} md={4} xl={4}>
          {projectDetail?.icon?.url && type !== "user" ? (
            <img
              alt="logo"
              src={projectDetail?.icon?.url}
              style={{
                width: 40,
                // height: 40,
                borderRadius: 8,
                // objectFit: "contain",
              }}
            />
          ) : (
            <Avatar
              shape="square"
              style={{
                backgroundColor: type === "user" ? "#000000" : PrimaryColor,
                verticalAlign: "middle",
              }}
              size="large"
              // gap={gap}
            >
              {type === "user" ? <UserOutlined /> : <RobotOutlined />}
            </Avatar>
          )}
        </Col>
        <Col
          xs={19}
          md={20}
          xl={20}
          style={{
            marginTop: 0,
            textAlign: "justify",
            lineHeight: 2,
          }}
        >
          <ReactMarkdown
            linkTarget="_blank"
            // remarkPlugins={[remarkGfm]} // Causing not able to render unicode characters properly
            components={{
              img: ({ node, ...props }) => {
                // console.log("img", node, props);

                return (
                  <div>
                    <Row
                      align="middle"
                      justify="end"
                      gutter={8}
                      style={{
                        transform: "translate(0px, 24px)",
                      }}
                    >
                      <Col
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          Modal.info({
                            icon: null,
                            title: null,
                            centered: true,
                            width: "70%",
                            okText: "Close",
                            closable: true,
                            maskClosable: true,
                            content: (
                              <img
                                alt="img"
                                src={props.src}
                                style={{
                                  width: "100%",
                                  // height: 200,
                                  borderRadius: 5,
                                  // border: "1px solid rgba(0,0,0,0.15)",
                                }}
                              />
                            ),
                          });
                        }}
                      >
                        <FullscreenOutlined style={{ fontSize: 20 }} />
                      </Col>
                    </Row>

                    <img
                      alt="img"
                      {...props}
                      style={{
                        width: "100%",
                        // height: 200,
                        borderRadius: 5,
                        // border: "1px solid rgba(0,0,0,0.15)",
                      }}
                    />
                  </div>
                );
              },
              // code: ({ node, ...props }) => {
              //   return (
              //     <div {...props}>
              //       <Row
              //         style={{
              //           backgroundColor: "#2f2f2f",
              //           color: "#fff",
              //           padding: "8px 16px",
              //           borderTopRightRadius: 5,
              //           borderTopLeftRadius: 5,
              //         }}
              //         justify={"space-between"}
              //       >
              //         <Col>Code</Col>
              //         <Col>
              //           <CopyToClipboard
              //             text={node.children[0].value}
              //             onCopy={() => message.success("Copied to clipboard")}
              //           >
              //             <span
              //               style={{
              //                 cursor: "pointer",
              //               }}
              //             >
              //               <FontAwesomeIcon icon={faCopy} /> Copy Code
              //             </span>
              //           </CopyToClipboard>
              //         </Col>
              //       </Row>
              //       <Row
              //         style={{
              //           backgroundColor: "#282c34",
              //           padding: "8px 16px",
              //           borderBottomRightRadius: 5,
              //           borderBottomLeftRadius: 5,
              //           width: "100%",
              //         }}
              //       >
              //         <Col
              //           span={24}
              //           style={{
              //             maxWidth: "100%",
              //           }}
              //         >
              //           <SyntaxHighlighter
              //             // language="javascript"
              //             // language="openapi"
              //             style={atomOneDark}
              //           >
              //             {node.children[0].value}
              //           </SyntaxHighlighter>
              //         </Col>
              //       </Row>
              //     </div>
              //   );
              // },
              a: ({ node, ...props }) => {
                // console.log(node, props, 304);
                return (
                  <a
                    {...props}
                    style={{
                      // fontWeight: "bold",
                      color: "#1677ff",
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => {
                      // if message is ###ERROR### then do nothing
                      if (disabled) {
                        // without e.preventDefault, it will open new tab
                        e.preventDefault();
                        return;
                      }

                      if (
                        node.properties.href === "#conversation-starter" ||
                        node.properties.href === "#conversation-list"
                      ) {
                        // without e.preventDefault, it will open new tab
                        e.preventDefault();

                        if (node.properties.href === "#conversation-starter") {
                          return setConversationStarterVisible(true);
                        }

                        setInput(node.children[0].value);

                        // Click on Regenerate button to regenerate the answer
                        setRegenerateInput(node.children[0].value);

                        setLinkClick(true);
                        // onSubmit();
                      }

                      console.log("node", node);
                      console.log("props", props);
                    }}
                  >
                    {node.children[0].value}
                  </a>
                );
              },
              // img: CustomImage,
            }}
          >
            {text}
            {/* {markdownText} */}
          </ReactMarkdown>
          {status === "waiting" && type === "system" && (
            <div style={{ marginTop: 4, width: 50, fontSize: 16 }}>
              <Lottie
                animationData={ChatLoadingAnimation}
                loop={true}
                style={{
                  height: 50,
                }}
              />
            </div>
          )}
          {status === "searching" && type === "system" && (
            <div
              style={{
                marginTop: 10,
                fontSize: 16,
                width: 32,
              }}
            >
              <Row
                justify={"start"}
                style={{
                  // width: "100%",
                  width: 320,
                }}
                align={"middle"}
              >
                <Col span={3}>
                  <Lottie
                    animationData={SearchKnowledgeAnimation}
                    loop={true}
                    style={{
                      height: 40,
                      width: 32,
                    }}
                  />
                </Col>
                <Col span={18}>
                  <TypeAnimation
                    style={{
                      width: "100%",
                      fontSize: 14,
                      color: "rgba(0,0,0,0.65)",
                    }}
                    sequence={[
                      `${action}`,
                      500,
                      `${action}.`, //  Continuing previous action
                      500,
                      `${action}...`,
                      500,
                    ]}
                    repeat={Infinity}
                  />
                </Col>
              </Row>
            </div>
          )}

          {status === "error" && type === "system" && (
            <div
              style={{
                marginTop: 0,
                width: 32,
              }}
            >
              <Row justify={"start"} align={"middle"}>
                <Col span={3}>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SyncOutlined />}
                    style={{
                      fontSize: 12,
                    }}
                    disabled={connectionError}
                    onClick={() => {
                      // console.log(id, question, 461);
                      handleRegenerate(id, question);
                      // setInput(regenerateInput);
                      // setLinkClick(true);
                    }}
                  >
                    Regenerate
                  </Button>
                </Col>
              </Row>
            </div>
          )}
        </Col>

        {/* Disable feedback */}
        {/* <Col
          span={24}
          offset={window.innerWidth < ScreenSize.md ? 6 : 0}
          style={{
            fontSize: 14,
          }}
        >
          <Row>
            <Col xs={5} md={3} xl={2}></Col>
            <Col
              xs={19}
              md={15}
              xl={20}
              style={{
                marginBottom: 8,
                marginTop: 4,
              }}
            >
              {type === "user" && (
                <CopyToClipboard
                  text={text}
                  onCopy={() => message.success("Copied to clipboard")}
                >
                  <FontAwesomeIcon icon={faCopy} {...actionButtonStyle} />
                </CopyToClipboard>
              )}
              {type === "system" && !hideAction && status === "final" && (
                <>
                  <Row>
                    <Col>
                      <CopyToClipboard
                        text={text}
                        onCopy={() => message.success("Copied to clipboard")}
                      >
                        <FontAwesomeIcon icon={faCopy} {...actionButtonStyle} />
                      </CopyToClipboard>
                    </Col>

                    <Col>
                      <LikeOutlined
                        onClick={() => {
                          if (!checkLikedOrDisLikedTrigger) {
                            ChatComment("liked");
                          } else {
                            message.error(
                              "You have already Liked/Disliked this answer."
                            );
                          }
                        }}
                        style={{
                          ...actionButtonStyle.style,
                          color: liked ? "#1890ff" : "rgba(0,0,0,0.65)",
                          backgroundColor: liked ? "#e6f7ff" : "rgba(0,0,0,0)",
                        }}
                      />
                    </Col>

                    <Col>
                      <DislikeOutlined
                        onClick={() => {
                          if (!checkLikedOrDisLikedTrigger) {
                            console.log("previousSelected", previousSelected);
                            console.log("currentSelected", currentSelected);
                            setVisible(true);
                          } else {
                            message.error(
                              "You have already Liked/Disliked this answer."
                            );
                          }
                        }}
                        style={{
                          ...actionButtonStyle.style,
                          color: disliked ? "red" : "rgba(0,0,0,0.65)",
                          backgroundColor: disliked
                            ? "#ffccc7"
                            : "rgba(0,0,0,0)",
                        }}
                      />
                    </Col>
                  </Row>
                </>
              )}
            </Col>
          </Row>
        </Col> */}
      </Row>

      {CommentModal}
    </div>
  );
};

export default memo(ChatBox);
